import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import mail from "../assets/icons/mail.png";
import call from "../assets/icons/telephone.png";
import facebook from "../assets/icons/facebook.png";
import instagram from "../assets/icons/instagram.png";
import whatsapp from "../assets/icons/whatsapp.png";
import twitter from "../assets/icons/twitter.png";
import pinterest from "../assets/icons/pinterest.png";
import linkedin from "../assets/icons/linkedin.png";
import youtube from "../assets/icons/youtube.png";
import appIcon from "../assets/icons/playstore.png";
import ios from "../assets/icons/apple.png";
import reviewimg from "../assets/reviews/heroreview.png";
import { useLocation } from "react-router";

const Footer = () => {
 const isUAEPath = window.location.pathname.startsWith("/uae");
   const currentLocation = useLocation();
 
   const basePath = currentLocation.pathname.startsWith("/uae")
   ? "/uae"
   : "/";
  const currentYear = new Date().getFullYear();
  const marketplace = `${basePath}market-place`;
  const downloads = `${basePath}downloads`;
  const about = `${basePath}about-us`;
  const ceodesk = `${basePath}ceo-desk`;
  const contact = `${basePath}contact-us`;
  const career = `${basePath}careers`

  const email = isUAEPath ? "ceo@timewatchuae.com" : "sales@timewatchindia.com";

  const phone = isUAEPath ? "+971-54-777-0637" : "+91-95999 53923";

  const insta = isUAEPath
    ? "https://www.instagram.com/timewatchuaeinfocom"
    : "https://www.instagram.com/timewatchindiainfocom/";

  const fb = isUAEPath
    ? "https://www.facebook.com/timewatchuae/"
    : "https://www.facebook.com/TimeWatchindia1";

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth", // for smooth scrolling
    });
  };

  return (
    <>
      <div
        className=" text-dark py-1 mb-0"
        style={{ backgroundColor: "#F7F7F7" }}
      >
        <div className="container mt-4">
          <div className="row g-4">
            {/* First Column */}
            <div className="col-md-4 mb-4">
              <p>
                <img
                  src={reviewimg}
                  alt="timewatchlogo"
                  style={{ maxWidth: "100%", marginBottom: "2rem" }}
                />
              </p>
              {!isUAEPath && (
              <p>
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3505.650669522068!2d77.27639937470376!3d28.52015608917643!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390cfd1c76f42c7f%3A0x3c367f721b229c13!2sTimeWatch%20Infocom%20Pvt.%20Ltd.!5e0!3m2!1sen!2sin!4v1726125861331!5m2!1sen!2sin"
                  width="90%"
                  height="110"
                  style={{ border: "0" }}
                  allowFullScreen
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="Google Map of TimeWatch Infocom Pvt. Ltd."
                ></iframe>
              </p>
              )}
            </div>

            {/* Second Column */}
            <div className="col-md-4 mb-2">
              <div className="d-flex justify-content-around">
                <ul className="list-unstyled" style={{ fontSize: "16px" }}>
                  <li>
                    <a
                      href={basePath}
                      onClick={(e) => {
                        scrollToTop();
                      }}
                      className="text-dark text-decoration-none"
                    >
                      Home
                    </a>
                  </li>
                  <li>
                    <a
                      href={`${about}`}
                      onClick={(e) => {
                        scrollToTop();
                      }}
                      className="text-dark text-decoration-none"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      About Us
                    </a>
                  </li>
                  <li>
                    <a
                      href={`${marketplace}`}
                      onClick={(e) => {
                        scrollToTop();
                      }}
                      className="text-dark text-decoration-none"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Market Place
                    </a>
                  </li>
                  <li>
                    <a
                      href={`${contact}`}
                      onClick={(e) => {
                        scrollToTop();
                      }}
                      className="text-dark text-decoration-none"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Contact Us
                    </a>
                  </li>
                  <li>
                    <a
                      href={`${ceodesk}`}
                      onClick={(e) => {
                        scrollToTop();
                      }}
                      className="text-dark text-decoration-none"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      CEO's Desk
                    </a>
                  </li>
                </ul>
                <ul className="list-unstyled" style={{ fontSize: "16px" }}>
                  <li>
                    <a
                      href={`${career}`}
                      onClick={(e) => {
                        scrollToTop();
                      }}
                      className="text-dark text-decoration-none"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Careers
                    </a>
                  </li>
                  {!isUAEPath && (
                    <li>
                    <a
                      href="/privacy-policy"
                      onClick={(e) => {
                        scrollToTop();
                      }}
                      className="text-dark text-decoration-none"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Privacy Policy
                    </a>
                  </li>
                  )}
                  {!isUAEPath && (
                  <li>
                    <a
                      href="/terms-conditions"
                      onClick={(e) => {
                        scrollToTop();
                      }}
                      className="text-dark text-decoration-none"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Terms & Conditions
                    </a>
                  </li>
                  )}
                  {!isUAEPath && (
                  <li>
                    <a
                      href="/disclaimer"
                      onClick={(e) => {
                        scrollToTop();
                      }}
                      className="text-dark text-decoration-none"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Disclaimer
                    </a>
                  </li>
                  )}
                  {!isUAEPath && (
                  <li>
                    <a
                      href="/e-waste"
                      onClick={(e) => {
                        scrollToTop();
                      }}
                      className="text-dark text-decoration-none"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      E Waste
                    </a>
                  </li>
                  )}
                </ul>
              </div>
            </div>
            {/* Third Column */}
            <div className="col-md-4 mb-0 d-flex flex-column align-items-center align-items-md-start">
              <p
                className="mb-1 text-center text-md-start"
                style={{ fontSize: "15px" }}
              >
                <span className="fw-bold">Email:</span>
                <a
                  href={`mailto:${email}`}
                  style={{ textDecoration: "none", color: "inherit" }}
                >
                  &nbsp; {email}
                </a>
              </p>

              <p
                className="mb-1 text-center text-md-start"
                style={{ fontSize: "15px" }}
              >
                <span className="fw-bold">Contact:</span>
                <a
                  href={`tel:${phone}`}
                  style={{ textDecoration: "none", color: "inherit" }}
                >
                  &nbsp; {phone}
                </a>
              </p>

              {!isUAEPath && (
                <p
                  className="mb-1 text-center text-md-start"
                  style={{ fontSize: "15px" }}
                >
                  <span className="fw-bold">Sales & Technical:</span>
                  <a
                    href="tel:+919599953923"
                    style={{ textDecoration: "none", color: "inherit" }}
                  >
                    &nbsp; 011-4191-6615
                  </a>
                </p>
              )}
              {!isUAEPath && (
              <p
                className="mb-1 text-center text-md-start"
                style={{ fontSize: "15px" }}
              >
                <span className="fw-bold">Address:</span>
                <a
                  href="https://maps.app.goo.gl/u9kHK1MvEVLsA4E6A"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ textDecoration: "none", color: "inherit" }}
                >
                  &nbsp; D-162, Okhla Phase - I
                </a>
              </p>
              )}
               {!isUAEPath && (
              <p
                className="mb-1 text-center text-md-start"
                style={{ fontSize: "15px" }}
              >
                New Delhi - 110020
              </p>
               )}
              
              {!isUAEPath && (
              <p className="mt-4 text-center">
                <img
                  src="https://timewatch.co.in/images/gateway.png"
                  alt="gateway"
                  style={{ maxWidth: "100%" }}
                />
              </p>
              )}
            </div>
          </div>

          {/* Social Links Row */}
          <div className="row justify-content-center mb-4">
            <div className="col-12">
              <div className="d-flex justify-content-center align-items-center flex-wrap gap-3">
                {!isUAEPath && (
                  <a
                    href="https://wa.me/919599953923?text=Hello%F0%9F%91%8B%F0%9F%8F%BB%20TimeWatch%2C%0AI%27m%20Interested%20in%20your%20product%20or%20services%0APlease%20Assist%20me%21%20%20"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img src={whatsapp} alt="whatsapp" width="30" height="30" />
                  </a>
                )}
                <a
                  href={`${insta}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={instagram} alt="instagram" width="30" height="30" />
                </a>
                <a
                  href={`${fb}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={facebook} alt="facebook" width="30" height="30" />
                </a>
                <a
                  href="https://www.linkedin.com/company/timewatchindia/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={linkedin} alt="linkedin" width="30" height="30" />
                </a>
                <a href={`mailto:${email}`}>
                  <img src={mail} alt="mail" width="30" height="30" />
                </a>
                <a href={`tel:${phone}`}>
                  <img src={call} alt="call" width="30" height="30" />
                </a>
                <a
                  href="https://www.youtube.com/@Timewatchinfocomindia"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={youtube} alt="youtube" width="30" height="30" />
                </a>
                <a
                  href="https://twitter.com/timewatchbiome"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={twitter} alt="twitter" width="30" height="30" />
                </a>
                <a
                  href="https://in.pinterest.com/timewatchinfocom/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={pinterest} alt="pinterest" width="30" height="30" />
                </a>
                <a
                  href="https://play.google.com/store/apps/details?id=com.timewatch.phoneapp&hl=en_IN&pli=1"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={appIcon} alt="app" width="30" height="30" />
                </a>
                <a
                  href="https://apps.apple.com/in/app/timewatch-mobile-attendance/id6482852039"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={ios} alt="app" width="30" height="30" />
                </a>
              </div>
            </div>
          </div>

          {/* Note */}
          <div className="row">
            <div className="col-12 text-center mb-0">
              <p style={{ fontSize: "12px" }}>
                Our business does not involve selling on e-commerce platforms.
              </p>
            </div>
          </div>
        </div>
      </div>
      {/* Copyright Strip */}
      <div className="bg-danger text-white text-center py-2">
        <p className="mb-0" style={{ fontSize: "10px" }}>
          TimeWatch <span>&#169;</span> {currentYear}, All Rights Reserved
        </p>
      </div>
    </>
  );
};

export default Footer;
